var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dsio-close-filters lcol lcol-12 lgrid-center" },
    [
      _c(
        "button",
        {
          staticClass: "button full colored lcol",
          on: { click: _vm.closeFilters },
        },
        [
          !_vm.isMobileScreen
            ? _c("i", { staticClass: "dsio-close" })
            : _vm._e(),
          _c("span", { domProps: { innerHTML: _vm._s(_vm.closeButtonLabel) } }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }